(function () {
  function init(section) {
    if (!section) return;

    var track = section.querySelector('.oddit-section-main-product__main-image');
    var thumbStrip = section.querySelector('.oddit-section-main-product__thumbs');
    var thumbs = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-main-product__thumb')
    );
    var slides = track
      ? Array.prototype.slice.call(
          track.querySelectorAll('.oddit-section-main-product__main-slide')
        )
      : [];

    function scrollToChild(scroller, child, smooth) {
      if (!scroller || !child) return;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      var delta =
        child.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      scroller.scrollBy({ left: delta, behavior: smooth ? 'smooth' : 'auto' });
    }

    function centerThumb(btn) {
      // 'nearest' handles both the mobile horizontal rail and the desktop vertical one
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    function setActiveThumb(i) {
      thumbs.forEach(function (b, n) {
        b.classList.toggle('oddit-section-main-product__thumb--active', n === i);
      });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        setActiveThumb(i);
        centerThumb(btn);
        scrollToChild(track, slides[i], true);
      });
    });

    // Swiping the main track drives the thumbnail selection
    if (track && slides.length) {
      var syncTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(function () {
          var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
          var nearest = 0;
          var best = Infinity;
          slides.forEach(function (sl, n) {
            var r = sl.getBoundingClientRect();
            var d = Math.abs(r.left + r.width / 2 - mid);
            if (d < best) {
              best = d;
              nearest = n;
            }
          });
          setActiveThumb(nearest);
          if (thumbs[nearest]) centerThumb(thumbs[nearest]);
        }, 100);
      });
    }

    // Variant radio group
    section.querySelectorAll('.oddit-section-main-product__variant').forEach(function (v) {
      v.addEventListener('click', function () {
        section.querySelectorAll('.oddit-section-main-product__variant').forEach(function (o) {
          o.classList.remove('oddit-section-main-product__variant--active');
          o.setAttribute('aria-checked', 'false');
        });
        v.classList.add('oddit-section-main-product__variant--active');
        v.setAttribute('aria-checked', 'true');
      });
    });

    // Purchase option toggle
    var sellingPlanInput = section.querySelector('[data-selling-plan-input]');
    var sellingPlanSelect = section.querySelector('[data-selling-plan-select]');
    var subscribePrice = section.querySelector('[data-subscribe-price]');
    var saveBadge = section.querySelector('[data-save-badge]');
    var variantIdInput = section.querySelector('[data-variant-id-input]');
    var addToCart = section.querySelector('[data-add-to-cart]');
    var buttonLabel = section.querySelector('[data-button-label]');
    var priceDisplay = section.querySelector('.oddit-section-main-product__price');
    var compareAtDisplay = section.querySelector('[data-compare-at-price]');
    var pricePer = section.querySelector('[data-price-per]');
    var purchaseShown = section.querySelectorAll('[data-purchase-show]');

    var variantData = {};
    var variantJson = section.querySelector('[data-oddit-variants]');
    if (variantJson) {
      try {
        variantData = JSON.parse(variantJson.textContent);
      } catch (e) {
        variantData = {};
      }
    }

    var optionRows = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-main-product__variants-row[data-option-index]')
    );

    // Which option value is active in each row, ordered by option position
    function selectedOptions() {
      var values = [];
      optionRows.forEach(function (row) {
        var active = row.querySelector(
          '.oddit-section-main-product__variant--active[data-variant-option]'
        );
        if (!active) return;
        var position = parseInt(active.dataset.optionPosition, 10) || 1;
        values[position - 1] = active.dataset.variantOption;
      });
      return values;
    }

    function currentVariantId() {
      var wanted = selectedOptions();
      if (!wanted.length) return variantIdInput ? variantIdInput.value : null;
      var match = Object.keys(variantData).filter(function (id) {
        return wanted.every(function (value, i) {
          return value === undefined || variantData[id].options[i] === value;
        });
      });
      return match[0] || null;
    }

    function isSubscribing() {
      var active = section.querySelector(
        '.oddit-section-main-product__purchase-option--active'
      );
      return !!active && active.dataset.purchaseType === 'subscribe';
    }

    // The form only carries a selling_plan when the subscribe option is active
    function syncSellingPlan() {
      if (sellingPlanInput) {
        sellingPlanInput.value =
          isSubscribing() && sellingPlanSelect ? sellingPlanSelect.value : '';
        // A blank selling_plan is not the same as no selling_plan — disabled inputs
        // are skipped by FormData, so the param is omitted rather than sent empty.
        sellingPlanInput.disabled = !sellingPlanInput.value;
      }
      // ponytail-debug: remove once the one-time / subscribe toggle is confirmed
      console.log('[oddit-product] syncSellingPlan', {
        subscribing: isSubscribing(),
        selectValue: sellingPlanSelect ? sellingPlanSelect.value : null,
        inputFound: !!sellingPlanInput,
        inputValue: sellingPlanInput ? sellingPlanInput.value : null,
        inputsInDom: document.querySelectorAll('[name="selling_plan"]').length
      });
      // Sibling-product cards carry a subscribe and a one-time badge + price
      var purchaseType = isSubscribing() ? 'subscribe' : 'one-time';
      purchaseShown.forEach(function (el) {
        el.hidden = el.dataset.purchaseShow !== purchaseType;
      });
      syncVariant();
    }

    function syncVariant() {
      var id = currentVariantId();
      var variant = id ? variantData[id] : null;
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = id;

      // Subscribing shows the plan price; falling back to the one-time price when
      // this variant has no allocation for the selected plan.
      var plan = sellingPlanSelect ? variant.plans[sellingPlanSelect.value] : null;
      var price = isSubscribing() && plan ? plan.price : variant.price;

      // The plan options are rendered from the initial variant and never re-rendered,
      // so a variant without an allocation for the selected plan would otherwise submit
      // a stale id while the button shows the one-time price.
      if (sellingPlanInput && !plan) sellingPlanInput.value = '';

      if (subscribePrice && plan) subscribePrice.textContent = plan.price;

      if (saveBadge) {
        var saved = plan ? plan.save : 0;
        saveBadge.hidden = saved <= 0;
        saveBadge.textContent = saveBadge.dataset.savePrefix + ' ' + saved + '%';
      }

      if (priceDisplay) priceDisplay.textContent = price;

      var paidAmount =
        isSubscribing() && plan ? plan.priceAmount : variant.priceAmount;

      if (compareAtDisplay) {
        // A subscription price is struck against the one-time price; the compare-at
        // price only applies to the one-time price.
        var compareText = variant.compareAt;
        var compareAmount = variant.compareAtAmount;
        if (variant.priceAmount > paidAmount) {
          compareText = variant.price;
          compareAmount = variant.priceAmount;
        }
        var showCompareAt = !!compareText && compareAmount > paidAmount;
        if (showCompareAt) compareAtDisplay.textContent = compareText;
        compareAtDisplay.hidden = !showCompareAt;
      }

      // Per-serving price for what is being paid; null without a servings count,
      // in which case the server-rendered text is left alone.
      var per = isSubscribing() && plan ? plan.per : variant.per;
      if (pricePer && per) {
        pricePer.textContent = pricePer.dataset.pricePerTemplate.replace('[price]', per);
      }

      if (addToCart) {
        addToCart.disabled = !variant.available;
        addToCart.dataset.variantId = id;
      }
      if (buttonLabel) {
        buttonLabel.textContent = variant.available
          ? addToCart.dataset.labelBase + ' • ' + price
          : addToCart.dataset.labelSoldOut;
      }
    }

    optionRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-variant-option]');
        if (!btn || !row.contains(btn)) return;
        row
          .querySelectorAll('[data-variant-option]')
          .forEach(function (b) {
            b.classList.remove('oddit-section-main-product__variant--active');
          });
        btn.classList.add('oddit-section-main-product__variant--active');
        syncVariant();
      });
    });

    syncSellingPlan();

    if (sellingPlanSelect) {
      // syncVariant() repaints the plan price and save badge from the variant data
      sellingPlanSelect.addEventListener('change', syncSellingPlan);
    }

    var purchaseOptions = section.querySelectorAll('.oddit-section-main-product__purchase-option');
    purchaseOptions.forEach(function (opt) {
      var isActive = opt.classList.contains('oddit-section-main-product__purchase-option--active');
      opt.setAttribute('role', 'radio');
      opt.setAttribute('aria-checked', isActive ? 'true' : 'false');
      opt.setAttribute('tabindex', isActive ? '0' : '-1');

      function select() {
        purchaseOptions.forEach(function (o) {
          o.classList.remove('oddit-section-main-product__purchase-option--active');
          o.setAttribute('aria-checked', 'false');
          o.setAttribute('tabindex', '-1');
        });
        opt.classList.add('oddit-section-main-product__purchase-option--active');
        opt.setAttribute('aria-checked', 'true');
        opt.setAttribute('tabindex', '0');
        syncSellingPlan();
      }

      opt.addEventListener('click', function (e) {
        if (e.target.closest('.oddit-section-main-product__delivery-select')) {
          // Clicking the frequency picker shouldn't fight the radio, but it does
          // imply the shopper wants the subscribe option.
          select();
          return;
        }
        select();
      });

      opt.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Enter') return;
        if (e.target.closest('.oddit-section-main-product__delivery-select')) return;
        e.preventDefault();
        select();
        opt.focus();
      });
    });
  }

  // Init on page load
  init(document.querySelector('.oddit-section-main-product'));

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.oddit-section-main-product');
    if (el) init(el);
  });
})();